import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import styles from './FileBreadCrumb.module.scss'

export interface FileBreadCrumbItemProps {
  isCurrent?: boolean
  isRoot?: boolean
  shrink?: boolean
  hide?: 'large' | 'small'
}

export function FileBreadCrumbItem({
  children,
  isCurrent = false,
  isRoot = false,
  shrink = false,
  hide,
}: PropsWithChildren<FileBreadCrumbItemProps>) {
  const Item = isCurrent ? 'h1' : 'span'
  return (
    <Item
      className={clsx(isCurrent ? styles.currentItem : styles.item, {
        [styles.shrink]: shrink,
        [styles.hideSmall]: hide === 'small',
        [styles.hideLarge]: hide === 'large',
        [styles.root]: isRoot,
      })}
    >
      {children}
    </Item>
  )
}
